/**
 * Verbos: the infinitive, type what it means.
 *
 * The same shared card every translation deck uses. The verb-specific part is
 * on the BACK, where the conjugation is.
 */
import { TypeTranslationCardFront } from '@/components/practice/TypeTranslationCard';

import type { CardFrontProps } from '../types';

import type { VerboPayload } from './types';

export function CardFront({ card, onAnswer }: CardFrontProps<VerboPayload>) {
  return <TypeTranslationCardFront card={card} onAnswer={onAnswer} headword={card.de} />;
}
